import { IconButton as MuiIconButton, Tooltip } from '@mui/material';

function IconButton(props: {
    title: string;
    size?: 'small' | 'medium' | 'large';
    color?: 'success' | 'warning' | 'error' | 'primary' | 'default';
    onClick: (event: React.MouseEvent<HTMLElement>) => void;
    IconComponent: React.ElementType;
    disabled?: boolean;
    placement?: 'top' | 'bottom';
}) {
    const { IconComponent } = props;
    const size = props.size || 'medium';
    if (props.disabled) {
        return renderButton();
    }
    return (
        <Tooltip title={props.title} placement={props.placement}>
            {renderButton()}
        </Tooltip>
    );

    function renderButton() {
        return (
            <MuiIconButton
                size={size}
                disabled={props.disabled}
                onClick={props.onClick}
                color={props.color}
            >
                <IconComponent fontSize={size} />
            </MuiIconButton>
        );
    }
}

export { IconButton };
